export default __webpack_public_path__ + "static/media/coupon_received.fdf79c0c.png";